import React from 'react';
import { Bot, Workflow, Database, Shield, Zap, GitBranch, Network, Sparkles } from 'lucide-react';
import FinalCTA from '../components/FinalCTA';
import AutomationDiagram from '../components/AutomationDiagram';
import Dashboard from '../components/Dashboard';

const capabilities = [
  { icon: Bot, title: 'AI Agents', desc: 'GPT-powered agents handling sales follow-ups, support replies and ops triage 24/7.' },
  { icon: Workflow, title: 'Workflow Automation', desc: 'Zapier / n8n / custom integrations stitching together your tools end-to-end.' },
  { icon: Database, title: 'Data Pipelines', desc: 'Clean, structured data flowing into a single source of truth for your business.' },
  { icon: Network, title: 'Multi-channel Routing', desc: 'WhatsApp, Email, Voice and Web—one inbox, intelligent triage, faster response.' },
  { icon: GitBranch, title: 'Conditional Logic', desc: 'Decision trees that route work to humans only when judgment is required.' },
  { icon: Shield, title: 'Compliance Ready', desc: 'Indian DPDP, GST and RBI-aligned workflows where applicable.' },
  { icon: Zap, title: 'Real-time Alerts', desc: 'Slack / WhatsApp pings the moment KPIs deviate from your targets.' },
  { icon: Sparkles, title: 'Continuous Learning', desc: 'Agents improve from every interaction with your team’s feedback loop.' },
];

const AISystemPage = () => {
  return (
    <div>
      <section className="relative pt-36 pb-16 overflow-hidden">
        <div className="absolute inset-0 bg-radial-glow pointer-events-none" />
        <div className="absolute inset-0 bg-grid opacity-30 pointer-events-none" />
        <div className="relative max-w-4xl mx-auto px-6 text-center">
          <p className="text-[#1AB6FF] font-semibold uppercase tracking-[0.2em] text-xs mb-4">AI System</p>
          <h1 className="font-display font-bold text-5xl md:text-6xl leading-[1.05]">
            The Geekynd AI Stack — <span className="gradient-text">built for India.</span>
          </h1>
          <p className="mt-6 text-white/65 text-lg max-w-2xl mx-auto">
            A composable AI layer that plugs into your existing tools and learns from every interaction. Indic-language ready, GST-aware, and operationally proven.
          </p>
        </div>
      </section>

      <section className="py-12 lg:py-16">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {capabilities.map((c) => (
            <div key={c.title} className="card-tech rounded-2xl p-6">
              <div className="w-12 h-12 rounded-lg bg-[#1AB6FF]/10 border border-[#1AB6FF]/25 flex items-center justify-center mb-4">
                <c.icon size={22} className="text-[#1AB6FF]" />
              </div>
              <h3 className="font-display font-semibold text-lg text-white">{c.title}</h3>
              <p className="mt-2 text-white/55 text-sm leading-relaxed">{c.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <AutomationDiagram />
      <Dashboard />
      <FinalCTA />
    </div>
  );
};

export default AISystemPage;
